module.exports = __webpack_public_path__ + "static/media/Travel.d21fcfdb.svg";